import Axios from "../../../../axios";
import {bellConstants, bellMusicApiConstants} from "../../../../constants/ApiConstant";

export async function saveBell(params) {
    return Axios.post(bellConstants.BELL_SAVE, params);
}

export async function searchBell(params) {
    return Axios.post(bellConstants.BELL_SEARCH, params);
}

export async function fetchBellMusicForDropDown() {
    return Axios.get(bellMusicApiConstants.BELL_MUSIC_FOR_DROPDOWN);
}

